// src/utils/excelStyles.js
import ExcelJS from 'exceljs';

export const createWorkbook = () => {
    const workbook = new ExcelJS.Workbook();
    return workbook;
};

export const createWorksheet = (workbook, title) => {
    const worksheet = workbook.addWorksheet(title);
    return worksheet;
};

export const addTitleRow = (worksheet, title) => {
    const titleRow = worksheet.addRow([title]);
    worksheet.mergeCells(`A1:L1`); // Adjust the range based on the number of columns
    titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
    const mergedTitleCell = worksheet.getCell('A1');
    mergedTitleCell.font = { bold: true, size: 14 };
};

export const addSummaryRow = (worksheet, summary) => {
    const summaryRow = worksheet.addRow([summary]);
    worksheet.mergeCells(`A2:L2`);
    summaryRow.alignment = { horizontal: 'center', vertical: 'middle' };
    const mergedSummaryCell = worksheet.getCell('A2');
    mergedSummaryCell.font = { bold: true, size: 12 };
};

export const addHeaders = (worksheet, headers) => {
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
};

export const applyCellStyles = (worksheet) => {
    worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        if (rowNumber === 3) { // Header row is the third row after title and summary
            row.font = { bold: true };
        }
    });
};

export const setColumnWidths = (worksheet, widths) => {
    widths.forEach((width, index) => {
        worksheet.getColumn(index + 1).width = width;
    });
};